import gsap from 'gsap';
import Sniffer from 'sniffer';

export default class Header {
  constructor() {
    this.scroll = document.querySelector('.a-scroll');
    this.page = document.querySelector('.a-scroll > div');

    this.section = document.querySelector('.s-header');
    this.src = document.querySelector('.s-header-src');
    this.indicator = document.querySelector('.s-header-indicator');
    this.scrollDown = document.querySelector('.scroll-down');

    this.offset = null;
  }

  inview = () => {
    if (Sniffer.isPhone) {
      this.offset = Math.abs(this.page.getBoundingClientRect().top);
    } else {
      this.offset = Math.abs(this.scroll.getBoundingClientRect().top);
    }

    const { top, bottom } = this.section.getBoundingClientRect();

    if (top < window.innerHeight * 0.9 && bottom > 0) {
      this.transform();
    }
  }

  transform = () => {
    this.src.style.transform = `matrix(${1 + this.offset / 2000}, 0, 0, ${1 + this.offset / 2000}, 0, ${this.offset / 2})`;
  }

  animate = () => {
    const tl = gsap.timeline();
    tl
      .set(this.indicator, {
        transformOrigin: '100% 0%',
      })
      .to(this.indicator, {
        scaleY: 1, duration: 1,
      })
      .set(this.indicator, {
        transformOrigin: '0% 100%',
      })
      .to(this.indicator, {
        scaleY: 0, duration: 1,
      })
      .set(this.scrollDown, {
        y: -40, autoAlpha: 0,
      })
      .to(this.scrollDown, {
        y: 0, autoAlpha: 1, duration: 1, delay: 0.25,
      });
  }

  run = () => {
    this.inview();
  }

  destroy() {
    gsap.ticker.remove(this.run);
  }

  init = () => {
    this.animate();
    gsap.ticker.add(this.run);
  }
}
